export enum GLOBAL_TEXTS {
  LOADING = "AADF9D5E-F221-4C33-9C9F-5EB1F62BE071",
}